export default "__VITE_ASSET__Bko5Zzt3__"